module.exports = __webpack_public_path__ + "img/nasu-ways.57144fd8.jpg";